/**
 * Custom Pixar-style avatars for each VibeMate vibe type.
 * Gender-diverse mix — 3 female, 3 male.
 *
 * Female: Social Anchor, Night Owl, Free Spirit
 * Male:   Quiet Professional, Early Riser, Homebody
 */

export const VIBE_TYPE_AVATARS = {
  // ── Female avatars ────────────────────────────────────────────────────────
  social_anchor:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/2768be81172398e83d150f3b76d71408951424c77aa44327ef4db0385af89c05.png',
  // Warm, welcoming woman with curly hair, holding a bowl in a kitchen

  night_owl:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/784da10c2bc2f4f84fdeb2e483467939a052a10fc2eaa2908ee07ace78975145.png',
  // Cool, sleepy-chic woman with straight hair, late-night mug, moon/stars

  free_spirit:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/48d6c12671ca224636ce243af4a6e3a30ef7c07baf2ae3c410f0b6a755e035eb.png',
  // Peaceful woman with wavy auburn hair, eyes closed, tropical greenery

  // ── Male avatars ─────────────────────────────────────────────────────────
  quiet_professional:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/a30b0f5397f4db52b2b20c8a4a30d8299c108ce6e560300f9210da8bf008b740.png',
  // Guy with glasses reading a green book

  early_riser:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/f1fd7985c098c28f8592e80ae194b9509378b3fc7b16d182cda0fcb6f6493eef.png',
  // Energetic fist-pump guy with cartoon sun

  homebody:
    'https://static.prod-images.emergentagent.com/jobs/a93823b9-5736-4994-99c5-98aa6af135c7/images/668887c75e49d18799e6aefb83c99a5736a05c1492b68179439b53dd72458107.png',
  // Cozy guy with mug, warm lamp and plant
};

/**
 * Returns the vibe type avatar URL for a given vibe type key.
 */
export function getVibeTypeAvatar(vibeType) {
  return VIBE_TYPE_AVATARS[vibeType] || null;
}
